import {FormattedMessage} from "react-intl";
import React, {RefObject} from "react";
import esTranslation from "../i18n/es.json";
import enTranslation from "../i18n/en.json";
import ptTranslation from "../i18n/pt.json";
import {gsap} from "gsap";
import {isAndroid} from "react-device-detect";

export const getTopWidth = (textLine: RefObject, useTop: boolean = true, wextra: string = '5vw') : any => {
    const wstr = `calc(${wextra})`;
    return useTop? {
        top: textLine.current.getBoundingClientRect().top,
        width: wstr
    } : {
        bottom: textLine.current.getBoundingClientRect().bottom,
        width: wstr
    }
}

export const cw = (txt: RefObject, container: RefObject, prop = 'left', boost = 1.05) => {
    let offsetX = gsap.getProperty(container.current, prop);
    return (txt.current.offsetWidth + offsetX) * boost;
}

export const ch = (txt: RefObject, container: RefObject, boost = 1) => {
    return (txt.current.offsetTop + container.current.offsetTop) * boost;
}

export function getSpan(text: string[], idPrefix: string = 'txt', joinTag: Element = <br/>) {
    if (text) {
        const last = text.length - 1;
        if (joinTag.type!=='Element') {
            return <span id={idPrefix}>
                {text.map((value, index) => {
                    return <div key={index}>{getFM(value)}{index<last && joinTag}</div>}
                )}
            </span>
        } else {
            return text.map((value, index) => {
                return <span key={idPrefix + index} id={idPrefix + index} >
                        {getFM(value)}
                    {index<last && joinTag}
                   </span>
            });
        }
    }
    console.log('missing text');
    return <span>?</span>;
}

export function getFM(id) {
    if (id)
        return <FormattedMessage id={id} values={{b: chunks => (<b>{chunks}</b>)}}/>;
    else {
        return <span> </span>;
    }
}

export const Langs = {
    'es': {txt: 'ESP', msg: esTranslation },
    'en': {txt: 'ENG', msg: enTranslation },
    'pt': {txt: 'POR', msg: ptTranslation },
}
export const Languages = {
    'es': {txt: 'Español', msg: esTranslation },
    'en': {txt: 'English', msg: enTranslation },
    'pt': {txt: 'Português', msg: ptTranslation },
}

export function DisableScroll() {

    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    window.onscroll = function () {
        window.scrollTo(scrollLeft, scrollTop);
    };
    console.log('scroll disabled');

//    disableBodyScroll(document.documentElement.getElementsByClassName('.p-scene-container '));
//    disableScroll.on();
}

export function EnableScroll() {
  //enableBodyScroll(document.documentElement.getElementsByClassName('.p-scene-container '));
  window.onscroll = function () {};
}

export function ScrollSnap(snapHeight = window.innerHeight, refresh = 200) {
    let isScrolling;

    const scrollListener = function () {
        window.clearTimeout(isScrolling);
        const nn = document.activeElement?.nodeName;
        if (nn==='INPUT' || nn==='TEXTAREA') {
            return;
        }
        isScrolling = setTimeout(() => {
            let snapTo = Math.round(window.scrollY / snapHeight) * snapHeight;

            window.scrollTo({
                let: 0, top: snapTo,
                behavior: 'smooth'
            });
        }, refresh);
    };

    if (snapHeight>0) {
        //document.onscroll = () => scrollListener();
    } else {
        window.onscroll = function () {};
    }
}

export function isPortrait(): boolean {
    if(isAndroid)
        return window.screen.availHeight > window.screen.availWidth;
    else
        return window.matchMedia('(orientation: portrait)').matches
}

// ISO 3166-1 alpha-2
// ⚠️ No support for IE 11
export function countryToFlag(isoCode) {
    return typeof String.fromCodePoint !== 'undefined'
        ? isoCode
            .toUpperCase()
            .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397))
        : isoCode;
}

export const isProd = window.location.href.includes('etermax.com');
